export default __webpack_public_path__ + "static/media/logo-full.2594e154.svg";